export default "__VITE_ASSET__c43c2ff1__"